import React from "react";
import { Modal, TextInput, Button, SimpleGrid } from "@mantine/core";
import { useSetState } from "@mantine/hooks";
import { apiWithInterceptor } from "../../../../api";
import { showNotification } from "@mantine/notifications";
const CreateTheaterModal = ({ opened, setOpenModal, setDelete }) => {
  const [formInfo, setFormInfo] = useSetState({
    name: "",
    location: "",
  });

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          setOpenModal(false);
        }}
        title="Create Theater"
      >
        <form
          onSubmit={(e) => {
            // setOpenModal(false);
            e.preventDefault();
            apiWithInterceptor
              .post(`/theater`, {
                name: formInfo.name,
                location: formInfo.location,
              })
              .then((res) => {
                console.log(res);
                showNotification({
                  title: "Success",
                  message: "Theater created successfully",
                  color: "green",
                });
                setDelete(true);
                setOpenModal(false);
                setFormInfo({ name: "", location: "" });
              })
              .catch((err) => {
                showNotification({
                  title: "Error",
                  message: "Theater creation failed",
                  color: "red",
                });
                console.log(err);
              });
          }}
        >
          <SimpleGrid cols={1} spacing="lg">
            <TextInput
              label="Theater Name"
              placeholder="Enter the theater name"
              value={formInfo.name}
              onChange={(e) => {
                setFormInfo({ name: e.target.value });
              }}
            />
            <TextInput
              label="Theater Address"
              placeholder="Enter the theater location"
              value={formInfo.location}
              onChange={(e) => {
                setFormInfo({ location: e.target.value });
              }}
            />
            <Button type="submit">Create Theater</Button>
          </SimpleGrid>
        </form>
      </Modal>
    </>
  );
};

export default CreateTheaterModal;
